import React from 'react';

import { Grid, Typography } from '@mui/material';
import { Layout } from 'features/common/components/Layout';
import { FlightIssueRuleList } from '../../features/flightIssueRule/components/FlightIssueRuleList';

export const FlightIssueRuleListPage = (): JSX.Element => {
	return (
		<Layout>
			<Grid container paddingY={5} justifyContent={'center'}>
				<Grid item xs={12} sx={{ ml: 20 }}>
					<Typography variant="h4" style={{ fontWeight: 500 }}>
						Reglas de emisión de vuelos
					</Typography>
				</Grid>
				<Grid paddingY={5}>
					<FlightIssueRuleList />
				</Grid>
			</Grid>
		</Layout>
	);
};
